@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.faq.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.feature.faq.generated.resources/"

internal val Res.string.feature_faq: StringResource by lazy {
      StringResource("string:feature_faq", "feature_faq", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 986, 27),
      ))
    }

internal val Res.string.feature_faq_answer1: StringResource by lazy {
      StringResource("string:feature_faq_answer1", "feature_faq_answer1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 227),
      ))
    }

internal val Res.string.feature_faq_answer2: StringResource by lazy {
      StringResource("string:feature_faq_answer2", "feature_faq_answer2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 238, 143),
      ))
    }

internal val Res.string.feature_faq_answer3: StringResource by lazy {
      StringResource("string:feature_faq_answer3", "feature_faq_answer3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 382, 219),
      ))
    }

internal val Res.string.feature_faq_answer4: StringResource by lazy {
      StringResource("string:feature_faq_answer4", "feature_faq_answer4", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 602, 119),
      ))
    }

internal val Res.string.feature_faq_question1: StringResource by lazy {
      StringResource("string:feature_faq_question1", "feature_faq_question1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 722, 65),
      ))
    }

internal val Res.string.feature_faq_question2: StringResource by lazy {
      StringResource("string:feature_faq_question2", "feature_faq_question2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 788, 77),
      ))
    }

internal val Res.string.feature_faq_question3: StringResource by lazy {
      StringResource("string:feature_faq_question3", "feature_faq_question3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 866, 61),
      ))
    }

internal val Res.string.feature_faq_question4: StringResource by lazy {
      StringResource("string:feature_faq_question4", "feature_faq_question4", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 928, 57),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_faq", Res.string.feature_faq)
  map.put("feature_faq_answer1", Res.string.feature_faq_answer1)
  map.put("feature_faq_answer2", Res.string.feature_faq_answer2)
  map.put("feature_faq_answer3", Res.string.feature_faq_answer3)
  map.put("feature_faq_answer4", Res.string.feature_faq_answer4)
  map.put("feature_faq_question1", Res.string.feature_faq_question1)
  map.put("feature_faq_question2", Res.string.feature_faq_question2)
  map.put("feature_faq_question3", Res.string.feature_faq_question3)
  map.put("feature_faq_question4", Res.string.feature_faq_question4)
}
